import { Platform } from 'react-native';
import { spacing } from '../../shared/theme/spacing'
import { ticketColors } from '../../shared/theme/ticketColors';

export const posLayoutStyleDefs = {
  container: {
    flex: 1,
    minHeight: 0,
    backgroundColor: ticketColors.bg,
    padding: spacing.md,
  },

  /** Shell desk PC: canvas wash + borde suave (proto `.desk`). */
  posDeskShell: {
    flex: 1,
    minHeight: 0,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    borderRadius: 16,
    backgroundColor: ticketColors.bg,
    overflow: 'hidden' as const,
    gap: 0,
  },

  posMainLayout: {
    flex: 1,
    minHeight: 0,
    gap: spacing.lg,
    ...(Platform.OS === 'web' ? { height: '100%' as unknown as number } : null),
  },

  posMainLayoutWide: {
    flexDirection: 'row' as const,
    alignItems: 'stretch' as const,
    gap: 0,
  },

  posCatalogColumn: {
    flex: 1,
    minWidth: 0,
    minHeight: 0,
  },

  posCartDock: {
    width: '100%',
    borderTopWidth: 1,
    borderTopColor: ticketColors.ruleSoft,
    paddingTop: spacing.sm,
    backgroundColor: ticketColors.paper2,
  },

  posCartDockWide: {
    width: 340,
    maxWidth: 340,
    flexShrink: 0,
    borderTopWidth: 1,
    borderTopColor: ticketColors.ruleSoft,
    borderLeftWidth: 1,
    borderLeftColor: ticketColors.ruleSoft,
    paddingTop: 0,
    paddingLeft: 0,
    backgroundColor: ticketColors.paper2,
  },

  cartLinesScroll: {
    flexGrow: 0,
    minHeight: 0,
  },

  cartLinesScrollContent: {
    paddingHorizontal: 12,
  },
} as const;
